import Model from '../../ModelBinding/Model';
import InvoiceCollection from "../Invoice/InvoiceCollection";
import OrderLineItemCollection from "./OrderLineItemCollection";
import dayjs from 'dayjs';
import Mission from '../Mission/Mission';
import OperatorInvoiceCollection from '../OperatorInvoice/OperatorInvoiceCollection';

export default class OrderLineItem extends Model {
  public order_id?: string;
  public item_id?: string;
  public item_type?: string;
  public price?: number;
  public vat?: number;
  public currency?: string;
  public description?:string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public invoices?: InvoiceCollection;
  public mission?: Mission;
  public order_item_type?: string;
  public vat_rate?: number;
  public billable_at?: dayjs.Dayjs;
  public operator_invoices?: OperatorInvoiceCollection;
  public locked?: boolean;
  public draft?: boolean;

  bind() {
    this.order_id = this.getStringAttribute('order_id');
    this.item_id = this.getStringAttribute('item_id');
    this.item_type = this.getStringAttribute('item_type');
    this.description = this.getStringAttribute('description');
    this.price = this.getIntAttribute('price');
    this.vat = this.getIntAttribute('vat');
    this.currency = this.getStringAttribute('currency');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.invoices = this.getRelationCollection(
        'invoices',
        InvoiceCollection,
    ) as InvoiceCollection;
    this.operator_invoices = this.getRelationCollection(
      'operator_invoices',
      OperatorInvoiceCollection,
  ) as OperatorInvoiceCollection;
    this.mission = this.getRelation('mission', Mission) as Mission;
    this.order_item_type = this.getStringAttribute('order_item_type');
    this.vat_rate = this.getFloatAttribute('vat_rate');
    this.billable_at = this.getDateAttribute('billable_at');
    this.locked = this.getBooleanAttribute('locked');
    this.draft = this.getBooleanAttribute('draft');
  }

  static getCollection() {
    return OrderLineItemCollection;
  }
}
